import { ReactNode } from 'react';
import { Box } from '@storyofams/react-ui';
import { m } from 'framer-motion';

const MotionBox = m(Box);

export const HoverArea = ({ children }: { children: ReactNode }) => (
  <MotionBox width="100%" flexDirection="column" whileHover="hover">
    {children}
  </MotionBox>
);

export const ScaleOnHover = ({ children }: { children: ReactNode }) => (
  <MotionBox
    width="100%"
    height="100%"
    variants={{
      initial: {
        scale: 1,
      },
      hover: { scale: 1.06 },
    }}
    transition={{ ease: [0.25, 1, 0.5, 1], duration: 0.7 }}
  >
    {children}
  </MotionBox>
);
